export default function reducer(
  state = {
    segmentDefinition: '',
  },
  action
) {
  switch (action.type) {
    case 'GET_SEGMENT_DEFINITION_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_SEGMENT_DEFINITION_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        segmentDefinition: action.payload,
      };
    }
    case 'GET_SEGMENT_DEFINITION_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        segmentDefinition: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
